import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { ActivityLogActions } from './partials/activity-log'
import { AssociatePartyActions } from './partials/party'
import { AssociateRecordActions } from './partials/associate-records'
import { PrintRecordActions } from './partials/print-record'
import { RecordEditActions } from './partials/edit'

export const RecordActions = {
  ...ActivityLogActions,
  ...AssociatePartyActions,
  ...AssociateRecordActions,
  ...PrintRecordActions,
  ...RecordEditActions,

  createRecordModelWithPartyAndCase: async ({ commit }, recordData) => {
    return axiosRequest.
      post('/add_record_with_party', recordData).
      then(({ data }) => {
        commit('setRecord', data.record)
        return data.record
      }).
      catch(handleError)
  },

  destroyRecord: async (_, recordId) => {
    return axiosRequest.
      delete(`/records/${recordId}`).
      then(response => response.data).
      catch(handleError)
  },

  getRecord: async ({ commit }, recordId) => {
    return axiosRequest.
      get(`/records/${recordId}`).
      then(({ data }) => {
        commit('setRecord', data.record)
      }).
      catch(handleError)
  },

  getRecordUnassociatedParties: async ({ commit }, { id, ...params }) => {
    commit('setSearchLoading', true)

    return axiosRequest.
      get(`/records/${id}/unassociated_parties`, { params }).
      then(({ data }) => {
        commit('legalCase/setLegalCaseUnassociatedParties', data.unassociated_parties || {}, { root: true })
        commit('setSearchLoading', false)
      }).
      catch(handleError)
  },

  fetchRecords: async ({ commit }, requestData) => {
    commit('setSearchLoading', true)

    return axiosRequest.
      get('/records', { params: requestData.params }).
      then(({ data }) => {
        commit('setRecords', data.records || {})
        commit('setSearchLoading', false)
      }).
      catch(handleError)
  },

  getRecordById: async (_, recordId) => {
    return axiosRequest.
      get(`/records_by_id/${recordId}`).
      then(({ data }) => data.record).
      catch(handleError)
  },

  setCreateRecordDialog: ({ commit }, value) => {
    commit('setCreateRecordDialog', value, { root: true })
  },

  setRecord: ({ commit }, value) => commit('setRecord', value),

  updateRecord: async ({ commit }, requestData) => {
    return axiosRequest.
      patch(`/records/${requestData.recordId}`, {
        record: requestData.recordData,
      }).
      then(({ data }) => {
        commit('setRecord', data.record)
      }).
      catch(handleError)
  },
}
